import React, { createContext, useContext, useState } from "react";

// Tracks the current logical route (key + params) so the language switcher
// and hreflang tags can compute the equivalent path in the other language.
const PageContext = createContext({
  page: { routeKey: "home", params: {} },
  setPage: () => {},
});

export function PageProvider({ children }) {
  const [page, setPage] = useState({ routeKey: "home", params: {} });
  return (
    <PageContext.Provider value={{ page, setPage }}>
      {children}
    </PageContext.Provider>
  );
}

export const usePage = () => useContext(PageContext);
